/* =================================================================
   12. Toast
   ================================================================= */
let toastTimer: number | null = null;

/** Show a transient message at the bottom of the screen.
 *  @param msg      Text to display.
 *  @param duration Override the default 2400ms (e.g. for important confirmations). */
export function toast(msg: string, duration: number = 2400): void {
  const el = document.getElementById("toast");
  if (!el) return;
  el.textContent = msg;
  el.classList.add("show");
  if (toastTimer != null) clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => el.classList.remove("show"), duration);
}
